(function () {
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}



"use strict";
var $3d28d7f1aac198f5$var$GRID_SIZE = 4;
function $3d28d7f1aac198f5$var$copyBoard(board) {
    if (typeof structuredClone === "function") return structuredClone(board);
    return JSON.parse(JSON.stringify(board));
}
function $3d28d7f1aac198f5$var$createEmptyBoard() {
    return Array.from({
        length: $3d28d7f1aac198f5$var$GRID_SIZE
    }, function() {
        return Array($3d28d7f1aac198f5$var$GRID_SIZE).fill(0);
    });
}
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.initialState = initialState ? $3d28d7f1aac198f5$var$copyBoard(initialState) : $3d28d7f1aac198f5$var$createEmptyBoard();
        if (!this._loadState()) this._resetState();
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "_resetState",
            value: function _resetState() {
                this.board = $3d28d7f1aac198f5$var$copyBoard(this.initialState);
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "_loadState",
            value: function _loadState() {
                try {
                    if (typeof window !== "undefined" && window.localStorage) {
                        var data = window.localStorage.getItem("2048_game_state");
                        if (data) {
                            var savedState = JSON.parse(data);
                            this.board = savedState.board;
                            this.score = savedState.score;
                            this.status = savedState.status;
                            return true;
                        }
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Failed to load save:", error);
                }
                return false;
            }
        },
        {
            key: "saveState",
            value: function saveState() {
                try {
                    if (typeof window !== "undefined" && window.localStorage) window.localStorage.setItem("2048_game_state", JSON.stringify({
                        board: this.board,
                        score: this.score,
                        status: this.status
                    }));
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Failed to save state:", error);
                }
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "_executeMove",
            value: function _executeMove(moveLogic) {
                if (this.status !== "playing") return false;
                var oldBoard = JSON.stringify(this.board);
                moveLogic();
                var isChanged = oldBoard !== JSON.stringify(this.board);
                if (isChanged) this.afterMove();
                return isChanged;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                return this._executeMove(function() {
                    _this.board = _this.board.map(function(row) {
                        return _this.processRow(row);
                    });
                });
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                return this._executeMove(function() {
                    _this.board = _this.board.map(function(row) {
                        var reversed = (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                        return _this.processRow(reversed).reverse();
                    });
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                return this._executeMove(function() {
                    var _loop = function(i) {
                        var column = _this.board.map(function(row) {
                            return row[i];
                        });
                        var processedColumn = _this.processRow(column);
                        for(var j = 0; j < $3d28d7f1aac198f5$var$GRID_SIZE; j++)_this.board[j][i] = processedColumn[j];
                    };
                    for(var i = 0; i < $3d28d7f1aac198f5$var$GRID_SIZE; i++)_loop(i);
                });
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                return this._executeMove(function() {
                    var _loop = function(i) {
                        var column = _this.board.map(function(row) {
                            return row[i];
                        });
                        var processedColumn = _this.processRow((0, $227c6742e0ff6f82$export$71511d61b312f219)(column).reverse()).reverse();
                        for(var j = 0; j < $3d28d7f1aac198f5$var$GRID_SIZE; j++)_this.board[j][i] = processedColumn[j];
                    };
                    for(var i = 0; i < $3d28d7f1aac198f5$var$GRID_SIZE; i++)_loop(i);
                });
            }
        },
        {
            key: "start",
            value: function start() {
                this.board = $3d28d7f1aac198f5$var$copyBoard(this.initialState);
                this.status = "playing";
                this.score = 0;
                this.addRandomTile();
                this.addRandomTile();
                this.saveState();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this._resetState();
                try {
                    window.localStorage.removeItem("2048_game_state");
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error(e);
                }
            }
        },
        {
            key: "processRow",
            value: function processRow(row) {
                var numbers = row.filter(function(cell) {
                    return cell !== 0;
                });
                for(var i = 0; i < numbers.length - 1; i++)if (numbers[i].value === numbers[i + 1].value) {
                    var sum = numbers[i].value * 2;
                    numbers[i].value = sum;
                    numbers[i].mergedId = numbers[i + 1].id;
                    numbers[i + 1] = 0;
                    this.score += sum;
                    i++;
                }
                var result = numbers.filter(function(n) {
                    return n !== 0;
                });
                while(result.length < $3d28d7f1aac198f5$var$GRID_SIZE)result.push(0);
                return result;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var row = 0; row < $3d28d7f1aac198f5$var$GRID_SIZE; row++){
                    for(var col = 0; col < $3d28d7f1aac198f5$var$GRID_SIZE; col++)if (this.board[row][col] === 0) emptyCells.push({
                        row: row,
                        col: col
                    });
                }
                if (emptyCells.length === 0) return;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomIndex = emptyCells[randomIndex], targetRow = _emptyCells_randomIndex.row, targetCol = _emptyCells_randomIndex.col;
                this.board[targetRow][targetCol] = {
                    id: Math.random().toString(36).substring(2, 10),
                    value: Math.random() < 0.9 ? 2 : 4
                };
            }
        },
        {
            key: "afterMove",
            value: function afterMove() {
                this.addRandomTile();
                var win = this.board.some(function(row) {
                    return row.some(function(cell) {
                        return cell !== 0 && cell.value === 2048;
                    });
                });
                if (win) this.status = "win";
                else if (this.isGameOver()) this.status = "lose";
                this.saveState();
            }
        },
        {
            key: "isGameOver",
            value: function isGameOver() {
                for(var row = 0; row < $3d28d7f1aac198f5$var$GRID_SIZE; row++)for(var col = 0; col < $3d28d7f1aac198f5$var$GRID_SIZE; col++){
                    if (this.board[row][col] === 0) return false;
                }
                for(var row1 = 0; row1 < $3d28d7f1aac198f5$var$GRID_SIZE; row1++)for(var col1 = 0; col1 < $3d28d7f1aac198f5$var$GRID_SIZE; col1++){
                    var current = this.board[row1][col1].value;
                    if (col1 < $3d28d7f1aac198f5$var$GRID_SIZE - 1 && current === this.board[row1][col1 + 1].value) return false;
                    if (row1 < $3d28d7f1aac198f5$var$GRID_SIZE - 1 && current === this.board[row1 + 1][col1].value) return false;
                }
                return true;
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$elements = {
    score: document.querySelector(".header__score"),
    tileContainer: document.querySelector(".tile-container"),
    gameBoard: document.querySelector(".game-board"),
    startButton: document.querySelector(".header__button--start"),
    messages: (0, $227c6742e0ff6f82$export$71511d61b312f219)(document.querySelectorAll(".message")),
    winMessage: document.querySelector(".message-win"),
    loseMessage: document.querySelector(".message-lose")
};
var $197cd56b15c33885$var$CLASSES = {
    BUTTON_START: "header__button--start",
    BUTTON_RESTART: "header__button--restart",
    TILE: "tile",
    TILE_NEW: "tile-new",
    TILE_MERGED: "tile-merged",
    HIDDEN: "hidden"
};
var $197cd56b15c33885$var$touchStart = {
    x: 0,
    y: 0
};
function $197cd56b15c33885$var$setTileAttributes(tile, value, col, row) {
    tile.textContent = value.value;
    tile.className = [
        $197cd56b15c33885$var$CLASSES.TILE,
        "tile--".concat(value.value),
        "tile-position-".concat(col, "-").concat(row)
    ].join(" ");
}
function $197cd56b15c33885$var$handleMergedTile(value, col, row, activeIds) {
    if (!value.mergedId) return;
    var deadTile = document.getElementById(value.mergedId);
    if (deadTile) {
        deadTile.className = [
            $197cd56b15c33885$var$CLASSES.TILE,
            "tile--".concat(deadTile.textContent),
            "tile-position-".concat(col, "-").concat(row)
        ].join(" ");
        activeIds.push(value.mergedId);
        setTimeout(function() {
            return deadTile.remove();
        }, 150);
    }
    return true;
}
function $197cd56b15c33885$var$drawGame() {
    var board = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$elements.score.textContent = $197cd56b15c33885$var$game.getScore();
    var activeIds = [];
    board.forEach(function(rowArr, row) {
        rowArr.forEach(function(value, col) {
            if (value === 0) return;
            activeIds.push(value.id);
            var tile = document.getElementById(value.id);
            if (!tile) {
                tile = document.createElement("div");
                tile.id = value.id;
                $197cd56b15c33885$var$setTileAttributes(tile, value, col, row);
                $197cd56b15c33885$var$elements.tileContainer.appendChild(tile);
                tile.classList.add($197cd56b15c33885$var$CLASSES.TILE_NEW);
            } else $197cd56b15c33885$var$setTileAttributes(tile, value, col, row);
            if ($197cd56b15c33885$var$handleMergedTile(value, col, row, activeIds)) {
                tile.style.zIndex = 10;
                tile.classList.add($197cd56b15c33885$var$CLASSES.TILE_MERGED);
                setTimeout(function() {
                    return tile.classList.remove($197cd56b15c33885$var$CLASSES.TILE_MERGED);
                }, 200);
                delete value.mergedId;
            }
        });
    });
    $197cd56b15c33885$var$elements.tileContainer.querySelectorAll(".".concat($197cd56b15c33885$var$CLASSES.TILE)).forEach(function(tile) {
        if (!activeIds.includes(tile.id)) tile.remove();
    });
}
function $197cd56b15c33885$var$showStatusMessage(status) {
    $197cd56b15c33885$var$elements.messages.forEach(function(m) {
        return m.classList.add($197cd56b15c33885$var$CLASSES.HIDDEN);
    });
    if (status === "win") $197cd56b15c33885$var$elements.winMessage.classList.remove($197cd56b15c33885$var$CLASSES.HIDDEN);
    if (status === "lose") $197cd56b15c33885$var$elements.loseMessage.classList.remove($197cd56b15c33885$var$CLASSES.HIDDEN);
}
function $197cd56b15c33885$var$updateButtonToRestart() {
    if ($197cd56b15c33885$var$elements.startButton.classList.contains($197cd56b15c33885$var$CLASSES.BUTTON_START)) {
        $197cd56b15c33885$var$elements.startButton.classList.replace($197cd56b15c33885$var$CLASSES.BUTTON_START, $197cd56b15c33885$var$CLASSES.BUTTON_RESTART);
        $197cd56b15c33885$var$elements.startButton.textContent = "Restart";
    }
}
$197cd56b15c33885$var$elements.startButton.addEventListener("click", function(event) {
    event.preventDefault();
    $197cd56b15c33885$var$elements.messages.forEach(function(m) {
        return m.classList.add($197cd56b15c33885$var$CLASSES.HIDDEN);
    });
    if ($197cd56b15c33885$var$elements.startButton.classList.contains($197cd56b15c33885$var$CLASSES.BUTTON_START)) {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$updateButtonToRestart();
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$game.start();
    }
    $197cd56b15c33885$var$drawGame();
});
document.addEventListener("keydown", function(event) {
    var keyMap = {
        ArrowUp: function() {
            return $197cd56b15c33885$var$game.moveUp();
        },
        ArrowDown: function() {
            return $197cd56b15c33885$var$game.moveDown();
        },
        ArrowLeft: function() {
            return $197cd56b15c33885$var$game.moveLeft();
        },
        ArrowRight: function() {
            return $197cd56b15c33885$var$game.moveRight();
        }
    };
    if (!keyMap[event.key] || $197cd56b15c33885$var$game.getStatus() !== "playing") return;
    event.preventDefault();
    if (keyMap[event.key]()) {
        $197cd56b15c33885$var$drawGame();
        $197cd56b15c33885$var$updateButtonToRestart();
        $197cd56b15c33885$var$showStatusMessage($197cd56b15c33885$var$game.getStatus());
    }
});
$197cd56b15c33885$var$elements.gameBoard.addEventListener("touchstart", function(event) {
    $197cd56b15c33885$var$touchStart.x = event.touches[0].screenX;
    $197cd56b15c33885$var$touchStart.y = event.touches[0].screenY;
}, {
    passive: true
});
$197cd56b15c33885$var$elements.gameBoard.addEventListener("touchend", function(event) {
    var dx = event.changedTouches[0].screenX - $197cd56b15c33885$var$touchStart.x;
    var dy = event.changedTouches[0].screenY - $197cd56b15c33885$var$touchStart.y;
    var threshold = 30;
    if (Math.abs(dx) <= threshold && Math.abs(dy) <= threshold) return;
    if (Math.abs(dx) > Math.abs(dy)) dx > 0 ? $197cd56b15c33885$var$game.moveRight() : $197cd56b15c33885$var$game.moveLeft();
    else dy > 0 ? $197cd56b15c33885$var$game.moveDown() : $197cd56b15c33885$var$game.moveUp();
    $197cd56b15c33885$var$drawGame();
    $197cd56b15c33885$var$showStatusMessage($197cd56b15c33885$var$game.getStatus());
}, {
    passive: true
});
function $197cd56b15c33885$var$init() {
    var status = $197cd56b15c33885$var$game.getStatus();
    if (status === "idle") return;
    $197cd56b15c33885$var$elements.messages.forEach(function(m) {
        return m.classList.add($197cd56b15c33885$var$CLASSES.HIDDEN);
    });
    $197cd56b15c33885$var$updateButtonToRestart();
    $197cd56b15c33885$var$drawGame();
    $197cd56b15c33885$var$showStatusMessage(status);
}
$197cd56b15c33885$var$init();

})();
//# sourceMappingURL=index.0f9db775.js.map
